import { type VariantProps, cva } from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center justify-center text-2xs w-fit font-sans-bold whitespace-nowrap shrink-0 [&>svg]:pointer-events-none focus-visible:ring-primary/50 focus-visible:ring-[3px] -skew-x-[15deg] tracking-wider uppercase',
  {
    variants: {
      variant: {
        new: 'text-black',
        discount: 'text-red',
        topseller: 'text-black',
      },
      position: {
        'top-left': 'absolute top-3 left-5',
        'top-right': 'absolute top-1 right-5',
      },
    },
    defaultVariants: {
      variant: 'new',
      position: 'top-right',
    },
  }
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
